"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getBoundedValue = _interopRequireDefault(require("../../../../utils/numbers/getBoundedValue"));

var _Duration = _interopRequireDefault(require("../../../../utils/time/Duration"));

var _durationToMilliseconds = _interopRequireDefault(require("../../../../utils/time/durationToMilliseconds"));

var _roundTo = _interopRequireDefault(require("../../../../utils/roundTo"));

var _OverlayBase = _interopRequireDefault(require("../../OverlayBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DurationOverlay = function DurationOverlay(_ref) {
  var value = _ref.value,
      onHide = _ref.onHide,
      onChange = _ref.onChange,
      min = _ref.min,
      max = _ref.max,
      hourIncrements = _ref.hourIncrements,
      minuteIncrements = _ref.minuteIncrements,
      GA = _ref.GA;

  var sanitizeValue = function sanitizeValue(unsanitizedValue) {
    return (0, _getBoundedValue.default)(unsanitizedValue, min ? (0, _durationToMilliseconds.default)(min) : 0, max && (0, _durationToMilliseconds.default)(max));
  };

  var _useState = (0, _react.useState)(sanitizeValue((0, _durationToMilliseconds.default)(value))),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var setHandler = function setHandler(unitValue, unit, shouldApply) {
    var currentValue = new _Duration.default(internalValue);

    var proposedDuration = _objectSpread({}, currentValue.getDuration());

    proposedDuration[unit] = unit === 'minutes' ? (0, _roundTo.default)(minuteIncrements)((0, _getBoundedValue.default)(unitValue, 0, 59)) : (0, _roundTo.default)(hourIncrements)(unitValue);
    var proposedValue = (0, _durationToMilliseconds.default)(proposedDuration);
    var appliedValue = sanitizeValue(proposedValue);
    setInternalValue(appliedValue);

    if (shouldApply) {
      var _getDuration = new _Duration.default(appliedValue).getDuration(),
          _hours = _getDuration.hours,
          _minutes = _getDuration.minutes;

      onChange({
        hours: _hours,
        minutes: _minutes
      });
      onHide();
    }
  };

  var incrementHandler = function incrementHandler(increment, unit) {
    var proposedDuration = new _Duration.default(internalValue); // eslint-disable-next-line default-case

    switch (unit) {
      case 'hours':
        proposedDuration.addHours(increment);
        break;

      case 'minutes':
        proposedDuration.addMinutes(increment);
        break;
    }

    var appliedValue = sanitizeValue(proposedDuration.milliseconds);
    setInternalValue(appliedValue);
  };

  var _getDuration2 = new _Duration.default(internalValue).getDuration(),
      hours = _getDuration2.hours,
      minutes = _getDuration2.minutes;

  return _react.default.createElement(_OverlayBase.default, {
    onChange: setHandler,
    onIncrement: incrementHandler,
    value: {
      hours: hours,
      minutes: minutes
    },
    onHide: onHide,
    hourIncrements: hourIncrements,
    minuteIncrements: minuteIncrements,
    GA: GA,
    onApply: onChange
  });
};

var duration = (0, _propTypes.shape)({
  hours: _propTypes.number,
  minutes: _propTypes.number
});
DurationOverlay.propTypes = {
  value: duration.isRequired,
  onHide: _propTypes.func,
  onChange: _propTypes.func.isRequired,
  min: duration,
  max: duration,
  minuteIncrements: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  hourIncrements: _propTypes.number,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
DurationOverlay.defaultProps = {
  onHide: function onHide() {},
  min: undefined,
  max: undefined,
  minuteIncrements: 1,
  hourIncrements: 1,
  GA: undefined
};
var _default = DurationOverlay;
exports.default = _default;